import React, { useState, useEffect } from "react";
import withAuth from "./../../common/helper/auth-component.js";
import { connect } from "react-redux";
import DashboardService from "../../../services/dashboard-service.js";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import StatusBadge from "../../common/helper/transaction-status.component.js";
import { MESSAGES } from "../../constants/constants.js";

const ViewTransactionLifeCycle = () => {
  const [loading, setLoading] = useState(false);
  const [tracker, setTracker] = useState();
  const [trackingTransaction, setTrackingTransaction] = useState([]);
  const { id } = useParams();
  const getTransactionTracker = () => {
    setLoading(true);
    DashboardService.getTransactionTracker(id)
      .then((response) => {
        const data = response.data.data.transaction;
        console.log(response.data.data.tracker);
        setTrackingTransaction(response.data.data.tracker);
        setTracker(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };

  useEffect(() => {
    getTransactionTracker();
    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = ""; // Reset body color when ComponentOne unmounts
    };
  }, []);
  const naviagate = useNavigate();
  const back = () => {
    naviagate(-1);
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <h4
          className="updatename updatename2"
          style={{ marginTop: 0, fontWeight: 700, fontSize: "16px" }}
        >
          Transaction Lifecycle
        </h4>
        <div
          className="row"
          style={{
            backgroundColor: "white",
            padding: "10px",
            paddingLeft: "20px",
          }}
        >
          <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
              <a className="nav-link active_tab1" id="list_per_details">
                Transaction Information
              </a>
            </li>
          </ul>
          <div
            className="tab-content d-flex justify-content-left flex-nowrap"
            style={{ marginTop: "20px", marginBottom: 0, padding: 0 }}
          >
            <div className="tab-pane active" id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{ padding: "0px" }}>
                  <div className="row">
                    <div
                      className={
                        trackingTransaction.length === 0
                          ? "col-md-6"
                          : "col-md-4"
                      }
                    >
                      <div
                        className="col-md-12"
                        style={{
                          padding: "10px",
                          border: "1px solid #eff2f7",
                          borderRadius: "5px",
                          paddingLeft: "20px",
                        }}
                      >
                        <div
                          className="col-md-2"
                          style={{ lineHeight: "55px" }}
                        >
                          <div className="form-group frm" style={{}}>
                            <i
                              className="fa fa-exchange cssinr"
                              style={{
                                padding: "6px",
                                color: "cornflowerblue",
                                border: "1px solid cornflowerblue",
                                backgroundColor: "white",
                              }}
                              aria-hidden="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-10" style={{}}>
                          <div className="form-group frm" style={{}}>
                            <label htmlFor="f_name">TRANSACTION ID</label>
                            <p>{(tracker && tracker.order_code) || "-"}</p>
                          </div>
                        </div>
                        <div
                          className="col-md-2"
                          style={{ lineHeight: "55px" }}
                        >
                          <div className="form-group frm" style={{}}>
                            <i
                              className="fa fa-money cssinr"
                              style={{
                                padding: "6px",
                                color: "green",
                                border: "1px solid green",
                                backgroundColor: "white",
                              }}
                              aria-hidden="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-10" style={{}}>
                          <div className="form-group frm" style={{}}>
                            <label htmlFor="f_name">TRANSACTION AMOUNT</label>
                            <p>₹{(tracker && tracker.amount) || "-"}</p>
                          </div>
                        </div>

                        <div
                          className="col-md-2"
                          style={{ lineHeight: "55px" }}
                        >
                          <div className="form-group frm" style={{}}>
                            <i
                              className="fa fa-credit-card cssinr"
                              style={{
                                padding: "6px",
                                color: "salmon",
                                border: "1px solid salmon",
                                backgroundColor: "white",
                              }}
                              aria-hidden="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-10" style={{}}>
                          <div className="form-group frm" style={{}}>
                            <label htmlFor="f_name">PAYMENT METHOD</label>
                            <p>
                              {(tracker && tracker.payment_method_type) || "-"}
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-2"
                          style={{ lineHeight: "55px" }}
                        >
                          <div className="form-group frm" style={{}}>
                            <i
                              className="fa fa-check cssinr"
                              style={{
                                padding: "6px",
                                color: "green",
                                border: "1px solid green",
                                backgroundColor: "white",
                              }}
                              aria-hidden="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-10" style={{}}>
                          <div className="form-group frm" style={{}}>
                            <label htmlFor="f_name">TRANSACTION STATUS</label>
                            <p>
                              {" "}
                              <StatusBadge status={tracker && tracker.status} />
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-2"
                          style={{ lineHeight: "55px" }}
                        >
                          <div className="form-group frm" style={{}}>
                            <i
                              className="fa fa-calendar cssinr"
                              style={{
                                padding: "6px",
                                color: "orange",
                                border: "1px solid orange",
                                backgroundColor: "white",
                              }}
                              aria-hidden="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-10" style={{}}>
                          <div className="form-group frm" style={{}}>
                            <label htmlFor="f_name">REGISTERED ON</label>
                            <p>{(tracker && tracker.start_date) || "-"}</p>
                          </div>
                        </div>
                      </div>
                      <a
                        style={{ width: "auto", padding: "0px" }}
                        onClick={back}
                      >
                        <button
                          className="btn border rounded mt-4"
                          style={{ background: "#495a69", color: "white" }}
                        >
                          Back
                        </button>
                      </a>
                    </div>
                    <div className="col-md-6">
                      <div className="timeline" style={{ margin: 0 }}>
                        {/*first*/}
                        {trackingTransaction.map((transaction, index) => (
                          <>
                            <div className="timeline__event">
                              <div
                                className="timeline__event__content"
                                style={{
                                  background: index % 2 === 0 ? "#eafef2" : "",
                                }}
                              >
                                <div className="timeline__event__title">
                                  <div className="row">
                                    <div className="col-md-2 inrr">
                                      <i
                                        className="fa fa-inr cssinr"
                                        aria-hidden="true"
                                      />
                                    </div>
                                    <div
                                      className="col-md-10 inrr-mobile"
                                      style={{ padding: 0 }}
                                    >
                                      <span
                                        style={{
                                          color: "black",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {transaction.tracker_description}
                                      </span>
                                      <h6
                                        style={{
                                          fontSize: "11px",
                                          marginTop: "5px",
                                          marginBottom: 0,
                                          color: "#787c89",
                                        }}
                                      >
                                        {" "}
                                        {transaction.tracker_time}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {index !== trackingTransaction.length - 1 && (
                              <div className="line-in-middle" />
                            )}
                          </>
                        ))}

                        {/* <div className="timeline__event">
                          <div className="timeline__event__content ">
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-money cssinr" aria-hidden="true" style={{padding: '6px 6px'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Accepted by Agent/You</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> {tracker && tracker.agent_confirm_date}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#eafef2'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-check cssinr" aria-hidden="true" style={{padding: '6px 6px', background: '#129e47', color: 'white'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Payment Confirmed by customer</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> 23 Mar 2024 – 10:12:45 AM</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#eafef2'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-check cssinr" aria-hidden="true" style={{padding: '6px 6px', background: '#129e47', color: 'white'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Payment Approved by Admin</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> 23 Mar 2024 – 10:12:45 AM</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#eafef2'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-check cssinr" aria-hidden="true" style={{padding: '6px 6px', background: '#129e47', color: 'white'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Payment Approved/Confirmed by Merchant</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}>  {tracker && tracker.merchant_confirm_date}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#fff2d8'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-info cssinr" aria-hidden="true" style={{background: '#fdc651', fontSize: '14px', color: 'white', padding: '6px 10px'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Case Raised By Agent/You</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> {tracker && tracker.raised_by}</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#ffe3e2'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-close cssinr" aria-hidden="true" style={{padding: '6px 8px', background: '#fb5353', color: 'white'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Case Rejected By Admin</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> 23 Mar 2024 – 10:12:45 AM</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#eafef2'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-check cssinr" aria-hidden="true" style={{padding: '6px 6px', background: '#129e47', color: 'white'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Case Approved By Admin</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> 23 Mar 2024 – 10:12:45 AM</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="line-in-middle" />
                        <div className="timeline__event">
                          <div className="timeline__event__content " style={{background: '#eafef2'}}>
                            <div className="timeline__event__title">
                              <div className="row">
                                <div className="col-md-2 inrr">
                                  <i className="fa fa-check cssinr" aria-hidden="true" style={{padding: '6px 6px', background: '#129e47', color: 'white'}} />
                                </div>
                                <div className="col-md-10" style={{padding: 0}}>
                                  <span style={{color: 'black', fontSize: '13px'}}>Case Approved By Merchant</span>
                                  <h6 style={{fontSize: '11px', marginTop: '5px', marginBottom: 0, color: '#787c89'}}> 23 Mar 2024 – 10:12:45 AM</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(ViewTransactionLifeCycle));
